// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5da98903","453":"af79b39d"}[chunkId] + ".chunk.js";
};